export const WHATSAPP_NUMBER = 14437462273;
export const WHATSAPP_STRING = "+1 (443) 746-2273";
export const ORANGE_LINK_PACKAGE_IDS = ["0199356a-3e37-724a-b532-d9bfac1a4139"];
